// This icon file is generated automatically.
var CircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M64.42 508.11a437.52 437.52 0 10895.43 0 437.52 437.52 0 10-895.43 0z" } }] }, "name": "circle", "theme": "filled" };
export default CircleFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/CircleFilled.js
// module id = 2216
// module chunks = 0